import React, { useEffect, useState } from 'react';
import { Card, Select } from 'antd';
import { UserOutlined, QuestionCircleOutlined, EditOutlined, FileTextOutlined } from '@ant-design/icons';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { CommonInfoStat, QnaTicketCountStat, UserRegisterStat } from 'model/response';
import { getCommonInfoStat, getStatQnaTicketCount } from 'service/statisticService';
import { formatNumberWithCommas } from 'utils/utils';
import QnaTicketStatusPieChart from './components/QnaTicketCountChart';
import { QnaTicketTable } from '../QuestionAndAnswer/components/QnaTicketTable';
import UserRegisterChart from './components/UserRegisterStatChart';
import UserActionChart from './components/UserActionChart';
import MonthlyCompletionChart from './components/ExamPracticeChart';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);
const { Option } = Select;
const Dashboard = () => {
  const [commonInfo, setCommonInfo] = useState<CommonInfoStat | null>({});
  const [qnaTicketCountStatusData, setQnaTicketCountStatusData] = useState<QnaTicketCountStat[]>([])

  const getCommonInfo = () => {
    getCommonInfoStat().then((response) => {
      setCommonInfo(response);
    });
  };



  const initQnaTicketCountData = () => {
    getStatQnaTicketCount()
      .then(response => {
        setQnaTicketCountStatusData(response)
      })
  }

  useEffect(() => {
    getCommonInfo();
    initQnaTicketCountData()
  }, []);



  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Total Users */}
        <Card
          className="rounded-lg shadow-lg relative overflow-hidden"
          style={{ background: 'linear-gradient(135deg, rgb(239, 163, 96,0.7), rgb(232, 113, 99,0.8))' }}
          bordered={false}
        >
          <div className="absolute top-4 right-4 text-white text-3xl">
            <UserOutlined />
          </div>
          <img src="/assets/images/circle.png" className="absolute bottom-0 right-0" alt="circle background" />
          <div className="text-left flex flex-col text-white">
            <h2 className="text-lg font-medium">Số lượng người dùng</h2>
            <p className="text-3xl font-semibold mt-2">{formatNumberWithCommas(commonInfo?.totalUser)}</p>
          </div>
        </Card>

        {/* Total Questions */}
        <Card
          className="rounded-lg shadow-lg relative overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #82b2fe 0%, #c2e9fb 100%)' }}
          bordered={false}
        >
          <div className="absolute top-4 right-4 text-white text-3xl">
            <FileTextOutlined />
          </div>
          <img src="/assets/images/circle.png" className="absolute bottom-0 right-0" alt="circle background" />
          <div className="text-left flex flex-col text-white">
            <h2 className="text-lg font-medium">Số lượng đề thi</h2>
            <p className="text-3xl font-semibold mt-2">{formatNumberWithCommas(commonInfo?.totalExam)}</p>
          </div>
        </Card>

        {/* Total Contests */}
        <Card
          className="rounded-lg shadow-lg relative overflow-hidden"
          style={{ background: 'linear-gradient(135deg, rgb(243, 156, 18,0.8), rgb(230, 126, 34,0.8)' }}
          bordered={false}
        >
          <div className="absolute top-4 right-4 text-white text-3xl">
            <EditOutlined />
          </div>
          <img src="/assets/images/circle.png" className="absolute bottom-0 right-0" alt="circle background" />
          <div className="text-left flex flex-col text-white">
            <h2 className="text-lg font-medium">Số lượng bài luyện tập</h2>
            <p className="text-3xl font-semibold mt-2">{formatNumberWithCommas(commonInfo?.totalPractice)}</p>
          </div>
        </Card>
        <Card
          className="rounded-lg shadow-lg relative overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #6cfba1, #8fd3f4)' }}
          bordered={false}
        >
          <div className="absolute top-4 right-4 text-white text-3xl">
            <QuestionCircleOutlined />
          </div>
          <img src="/assets/images/circle.png" className="absolute bottom-0 right-0" alt="circle background" />
          <div className="text-left flex flex-col text-white">
            <h2 className="text-lg font-medium">Số lượng hỏi đáp</h2>
            <p className="text-3xl font-semibold mt-2">{formatNumberWithCommas(commonInfo?.totalQnaTicket)}</p>
          </div>
        </Card>
      </div>

      <div className="flex flex-col gap-4 md:gap-6 mt-8">
        {/* Row 1 */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-6">
          <Card className="flex-1 rounded-lg shadow-lg p-4 min-h-[200px] md:min-h-[300px]">
            <UserRegisterChart />
          </Card>

          <Card className="flex-1 rounded-lg shadow-lg p-4 min-h-[200px] md:min-h-[300px]">
            <UserActionChart />
          </Card>
        </div>

        {/* Row 2 - Responsive columns */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-6">
          <Card className="flex-1 rounded-lg shadow-lg p-4 min-h-[200px] md:min-h-[300px]">
            <QnaTicketStatusPieChart data={qnaTicketCountStatusData} />
          </Card>
          <Card className="flex-1 rounded-lg shadow-lg p-4 min-h-[200px] md:min-h-[300px]">
            <MonthlyCompletionChart />
          </Card>
        </div>

        {/* Qna Ticket Table */}
        <div className="flex-1">
          <QnaTicketTable hiddenFilter={true} subjectIdFilter="all" />
        </div>
      </div>

    </div>
  );
};

export default Dashboard;
